/**
 * The coordinate line: the fallback shown whenever a capture has no resolved place name (the lookup returned
 * nothing, failed, or is still in flight).
 *
 * Tolerates a missing number: draft pre-fill can hand back a stored URL with no coordinates (a row whose
 * `otherFields` is null), and `toFixed` on undefined throws.
 */
export const formatCoordinates = (latitude?: number | null, longitude?: number | null): string | null =>
  typeof latitude === "number" && typeof longitude === "number" ? `${latitude.toFixed(6)}, ${longitude.toFixed(6)}` : null;

/**
 * The moment the photo was taken, in the learner's own locale and 12/24-hour convention — "22 Oct, 03:45 pm".
 * No year: a capture is read minutes or days after it is taken, never months.
 */
export const formatCaptureTime = (capturedAt?: string | null): string | null => {
  if (!capturedAt) return null;
  const captured = new Date(capturedAt);
  if (Number.isNaN(captured.getTime())) return null;
  return captured.toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
};
